module.exports = __webpack_public_path__ + "img/plastico.04cb62df.png";